import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Github, Twitter, Mail, Download } from 'lucide-react';
import { personalInfo } from '../mock';
import { Button } from './ui/button';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialIcons = {
    Linkedin: Linkedin,
    Github: Github,
    Twitter: Twitter,
    Mail: Mail
  };

  const handleCVDownload = () => {
    // Mock CV download
    alert('CV download functionality will be implemented with backend!');
  };

  return (
    <footer className="bg-background border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link
              to="/"
              className="text-2xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent inline-block mb-4"
            >
              {personalInfo.name}
            </Link>
            <p className="text-muted-foreground mb-4 max-w-md">
              {personalInfo.tagline}
            </p>
            <Button
              onClick={handleCVDownload}
              className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white"
            >
              <Download className="mr-2 h-4 w-4" />
              Download CV
            </Button>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-muted-foreground hover:text-cyan-400 transition-colors"
                >
                  About Me
                </Link>
              </li>
              <li>
                <Link
                  to="/projects"
                  className="text-muted-foreground hover:text-cyan-400 transition-colors"
                >
                  Projects
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-muted-foreground hover:text-cyan-400 transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-muted-foreground hover:text-cyan-400 transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Get in Touch</h3>
            <ul className="space-y-2">
              <li className="text-muted-foreground">{personalInfo.email}</li>
              <li className="text-muted-foreground">{personalInfo.phone}</li>
              <li className="text-muted-foreground">{personalInfo.location}</li>
            </ul>
          </div>
        </div>

        {/* Social Links & Copyright */}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-muted-foreground text-sm">
            © {currentYear} {personalInfo.name}. All rights reserved.
          </p>

          <div className="flex space-x-4">
            <a
              href="https://linkedin.com/in/alexmorgan"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-cyan-400 transition-all hover:scale-110"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="https://github.com/alexmorgan"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-cyan-400 transition-all hover:scale-110"
            >
              <Github className="h-5 w-5" />
            </a>
            <a
              href="https://twitter.com/alexmorgan"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-cyan-400 transition-all hover:scale-110"
            >
              <Twitter className="h-5 w-5" />
            </a>
            <a
              href="mailto:alex.morgan@example.com"
              className="text-muted-foreground hover:text-cyan-400 transition-all hover:scale-110"
            >
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;